import { render, staticRenderFns } from "./mod-instruction.vue?vue&type=template&id=6130926f"
import script from "./mod-instruction.vue?vue&type=script&lang=js"
export * from "./mod-instruction.vue?vue&type=script&lang=js"
import style0 from "./_scss/instruction.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports